import React from 'react'
import { Trans } from 'react-i18next'
import { CustomButton, CustomText, Spacer } from './mixins'

const TextoRecomendados = ({ setShowModalRecomendados }) => {
  return (
    <>
      <CustomText>
        <Trans
          i18nKey="avisosRecomendadosIA.listado.cta"
          components={[
            <CustomButton
              key="cta-recomendados-listado"
              onClick={setShowModalRecomendados}
              buttonoptions={{ size: 'small', variant: 'primary', type: 'link' }}
            ></CustomButton>,
          ]}
        />
      </CustomText>

      <Spacer />
    </>
  )
}

export default TextoRecomendados
